import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";

import { vsLookupManagementServiceProviderName as contactBookLookupManagementServiceProviderName } from ".";
export const vsObjectName = "addressBookType";

export const contactBookTypeConfig = simpleLookupConfig(
  contactBookLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Book Type",
    namePlural: "Book Types",
    url: "/api/addressBook/addressBookType",
    defaultSort: "Name",
  }
);
